'use client'

import React from 'react'
import clsx from 'clsx'

export function SiteHeader({
  brand,
  nav,
  className,
}: {
  brand: React.ReactNode
  nav: React.ReactNode
  className?: string
}) {
  return (
    <header className={clsx('border-border bg-background text-foreground border-b py-2', className)}>
      <div className="mx-auto flex max-w-7xl items-center justify-between gap-4 px-4 py-4">
        {brand}
        {nav}
      </div>
    </header>
  )
}

export function SiteHeaderBrand({
  href = '/',
  className,
  children,
}: {
  href?: string
  className?: string
  children: React.ReactNode
}) {
  return (
    <a href={href} className={clsx('text-2xl font-semibold tracking-tight whitespace-nowrap', className)}>
      {children}
    </a>
  )
}

export function SiteHeaderNav({ children, className }: { children: React.ReactNode; className?: string }) {
  return <nav className={clsx('', className)}>{children}</nav>
}

export function SiteHeaderNavItem({
  href,
  active,
  className,
  children,
}: {
  href: string
  active?: boolean
  className?: string
  children: React.ReactNode
}) {
  return (
    <a
      href={href}
      className={clsx(
        'hover:text-primary transition-colors',
        {
          'text-primary font-semibold': active,
          'text-inherit': !active,
        },
        className
      )}
    >
      {children}
    </a>
  )
}
